<template>
  <div class="search-filter-container rounded-box box-shadow">
    <div class="filter-row">
      <!-- 카테고리 필터 -->
      <div class="filter-item">
        <label>카테고리</label>
        <a-select
          v-model:value="localFilters.categoryId"
          placeholder="전체"
          style="width: 180px"
          allowClear
          @change="handleFilterChange"
        >
          <a-select-option v-for="cat in categories" :key="cat._id" :value="cat._id">
            {{ cat.name }}
          </a-select-option>
        </a-select>
      </div>

      <!-- 상태 필터 -->
      <div class="filter-item">
        <label>상태</label>
        <a-select
          v-model:value="localFilters.status"
          placeholder="전체"
          style="width: 120px"
          allowClear
          @change="handleFilterChange"
        >
          <a-select-option value="active">활성</a-select-option>
          <a-select-option value="inactive">비활성</a-select-option>
        </a-select>
      </div>

      <!-- 태그 필터 -->
      <div class="filter-item">
        <label>태그</label>
        <a-select
          v-model:value="localFilters.tagId"
          placeholder="전체"
          style="width: 180px"
          allowClear
          @change="handleFilterChange"
        >
          <a-select-option v-for="tag in tags" :key="tag._id" :value="tag._id">
            <span class="tag-option" :style="{ backgroundColor: tag.color + '20', color: tag.color }">
              {{ tag.name }}
            </span>
          </a-select-option>
        </a-select>
      </div>

      <!-- 검색어 -->
      <div class="filter-item search-input-wrapper">
        <label>검색</label>
        <a-input-search
          v-model:value="localFilters.keyword"
          placeholder="QR코드명 또는 URL 검색"
          style="width: 280px"
          @search="handleSearch"
          @pressEnter="handleSearch"
        />
      </div>

      <!-- 버튼 그룹 -->
      <div class="filter-buttons">
        <a-button @click="handleReset">초기화</a-button>
        <a-button type="primary" class="yellow-button" @click="handleSearch">검색</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';

export default defineComponent({
  name: 'QrSearchFilter',
  props: {
    initialFilters: {
      type: Object,
      default: () => ({})
    },
    categories: {
      type: Array,
      default: () => []
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  emits: ['search', 'reset', 'filter-change'],
  setup(props, { emit }) {
    const defaultFilters = {
      categoryId: undefined,
      status: undefined,
      tagId: undefined,
      keyword: ''
    };

    const localFilters = ref({ ...defaultFilters, ...props.initialFilters });

    watch(() => props.initialFilters, (newVal) => {
      localFilters.value = { ...defaultFilters, ...newVal };
    }, { deep: true });

    const handleFilterChange = () => {
      emit('filter-change', { ...localFilters.value });
    };

    const handleSearch = () => {
      emit('search', { ...localFilters.value });
    };

    const handleReset = () => {
      localFilters.value = { ...defaultFilters };
      emit('reset', { ...localFilters.value });
    };

    return {
      localFilters,
      handleFilterChange,
      handleSearch,
      handleReset
    };
  }
});
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.search-filter-container {
  padding: $spacing-md;
  background-color: $bg-white;

  .filter-row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: $spacing-md;
  }

  .filter-item {
    display: flex;
    flex-direction: column;
    gap: $spacing-xs;

    label {
      font-size: $font-size-sm;
      color: $text-muted;
      font-weight: $font-weight-medium;
    }
  }

  .search-input-wrapper {
    flex: 1;
    min-width: 280px;
  }

  .filter-buttons {
    display: flex;
    gap: $spacing-sm;
    margin-left: auto;
  }

  .tag-option {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: $font-size-xs;
  }
}
</style>
